// @ts-check
import PropTypes from 'prop-types';
import { Component } from 'react';
import { SimpleSelect } from 'tombac/dist/components/Form/SimpleSelect';

class ThroughRegionSelect extends Component {
  constructor(props) {
    super(props);
    this.pickSlice = this.pickSlice.bind(this);
  }

  pickSlice(e) {
    const index = parseInt(e, 10);

    if (index === -1) {
      this.props.changeSlice(null);
      return;
    }

    return this.props.changeSlice(index);
  }

  render() {
    const { regionLabels, sliceIndex } = this.props;

    return (
      <div className="form-group">
        <SimpleSelect
          onChange={this.pickSlice}
          value={sliceIndex === null ? -1 : sliceIndex}
          $width="100%"
          selectProps={{
            placeholder: 'Select region',
          }}
          options={regionLabels.map((it, i) => ({ label: it, value: i }))}
        />
      </div>
    );
  }
}

ThroughRegionSelect.propTypes = {
  regionLabels: PropTypes.arrayOf(PropTypes.string),
  sliceIndex: PropTypes.number,
  changeSlice: PropTypes.func,
};

export default ThroughRegionSelect;
